import { authFetch } from './auth';
import { APP_CONFIG } from './config';

// ─────────────────────────────────────────────────────────────
// SUBMIT JOB APPLICATION
// Note: CV upload happens BEFORE this in StepPersonalInfo
//       formData.resume_link already contains the uploaded URL
// ─────────────────────────────────────────────────────────────

export async function submitApplication(formData) {

  // ── Validate required fields ──────────────────────────────
  const required = [
    'first_name', 'last_name', 'email',
    'phone', 'gender',
    'cid', 'branch_id', 'position_applying',
  ];

  for (const field of required) {
    if (!formData[field] && formData[field] !== 0) {
      throw new Error(`VALIDATION_ERROR: ${field} is required`);
    }
  }

  // ── Map form fields → API payload ─────────────────────────
  const payload = {
    FIRST_NAME:          formData.first_name,
    LAST_NAME:           formData.last_name,
    EMAIL:               formData.email,
    MOBILE_NO:           formData.phone,
    CNIC:                formData.cnic || null,
    ADDRESS:             formData.address             || null,

    RESUME_LINK:         formData.resume_link         || null,

    PREVIOUS_EXPERIENCE: formData.experience          || null,
    EXPECTED_SALARY:     formData.expected_salary     || null,
    HOW_HEAR:            formData.how_did_you_hear    || null,
    CID:                 Number(formData.cid),
    BID:                 Number(formData.branch_id),
    BRANCH_NAME:         formData.branch_name         || null,
    JOB_ID:              Number(formData.position_applying),
    GENDER:              formData.gender,
    EDUCATION:           formData.qualification       || null,
    FATHER_NAME:         formData.father_name         || null,
  };

  // ── Fire request ──────────────────────────────────────────
  let res;
  try {
    res = await authFetch(APP_CONFIG.APPLICATION_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept:         'application/json',
      },
      body: JSON.stringify(payload),
    });
  } catch (networkError) {
    throw new Error(`APPLICATION_NETWORK_ERROR: ${networkError.message}`);
  }

  let data;
  try {
    data = await res.json();
  } catch {
    throw new Error('APPLICATION_PARSE_FAILED: Response is not valid JSON');
  }

  if (!res.ok) {
    const apiMsg = data?.message || data?.error || res.status;
    throw new Error(`APPLICATION_SUBMIT_FAILED: ${apiMsg}`);
  }

  return data;
}